var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'person': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 1.771c-2.67 0-8 1.569-8 4.229v2h16v-2.229c0-2.66-5.33-4-8-4z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/person.js